import React from 'react';
import { useAppSelector } from "../../../../store/hooks";
import { selectUserById } from "../../../../store/sticker_maker/usersSlice";
import { selectStickerPackById } from "../../../../store/sticker_maker/stickerPacksSlice";

import { RightSidebar } from "../../../_partials/Layout";
import Meta from "../../Users/_partials/_Meta";
import { EntityId } from "@reduxjs/toolkit";
import {Tags} from "./_Tags";

const _SidebarShow = ({ id }: { id: EntityId | undefined }) => {
  const stickerPack = useAppSelector(state => id ? selectStickerPackById(state, id) : undefined);
  const user = useAppSelector(state => stickerPack?.user_id ? selectUserById(state, stickerPack?.user_id) : undefined);

  return (
    <RightSidebar>
      <h6 className='v-content-label'>CHOOSE OPTION</h6>
      <hr className="v-divider" />

      {user && <h6 className="v-content-label o-sm">User</h6>}
      {<Meta user={user} />}

      <h6 className="v-content-label o-sm v-mt-15">Tags</h6>
      {stickerPack && <Tags category_ids={stickerPack.category_ids} />}
    </RightSidebar>
  )
}

export default _SidebarShow;
